import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import type { RegisterDto } from '@fp3/shared'
import { authApi } from '../api/authApi'
import { useAuth } from './useAuth'

export const useRegister = () => {
  const navigate = useNavigate()
  const { login } = useAuth()

  return useMutation({
    mutationFn: (dto: RegisterDto) => authApi.register(dto),
    onSuccess: (data, variables) => {
      if (data.autoVerified && data.access_token && data.user) {
        login(data.access_token, data.user)
        navigate('/')
      } else if (data.autoVerified) {
        navigate('/login')
      } else {
        navigate('/check-email', { state: { email: variables.email } })
      }
    },
  })
}
